import { render, staticRenderFns } from "./CompanySelection.vue?vue&type=template&id=40f3a53b&scoped=true&"
import script from "./CompanySelection.vue?vue&type=script&lang=js&"
export * from "./CompanySelection.vue?vue&type=script&lang=js&"
import style0 from "./CompanySelection.vue?vue&type=style&index=0&id=40f3a53b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3a53b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VImg,VRow,VSkeletonLoader})
